<template>
    <div class="neirong">
        <a-row style="height:100%">
            <a-col :span="5" style="height:100%">
                <DetailLeft :info="info" />
            </a-col>
            <a-col :span="19" style="padding-left:50px">
                <DetailCenter :info="info" />
            </a-col>

        </a-row>
    </div>
</template>

<script>
import http from "@/api/http";
import DetailLeft from "./chuneng/DetailLeft.vue";
import DetailCenter from "./chuneng/DetailCenter.vue";
import { defineComponent, onMounted, ref } from "vue";
import { useStore } from "vuex";
export default defineComponent({
    name: 'JiZhan',
    components: {
        DetailLeft,
        DetailCenter
    },
    props: {

    },
    setup() {
        let info = ref({})
        const store = useStore()
        let stationid = store.getters['User/stationid']
        const getData = () => {
            http.get("/base_station/" + stationid + "/ems").then((res) => {
                info.value = res.data


            });
        };

        onMounted(() => {
            //组件挂载时的生命周期执行的方法

            getData();
        });
        return {

            getData, info

        };
    },
})
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.neirong {
    padding-top: 20px;
    height: 100%;
    background: url("@/assets/bg22.png");
    background-size: 100% 100%;
}
</style>
